module.exports = __webpack_public_path__ + "static/media/background-music.b3df5858.ogg";